import { createContext, type ReactNode, useContext, useMemo } from 'react';

import { getAccessToken } from '../auth/storefront-auth';
import { StorefrontApiService } from './storefront-api';

const StorefrontApiContext = createContext<StorefrontApiService | null>(null);

/**
 * Provides a single {@link StorefrontApiService} bound to the PKCE token store
 * so screen containers can resolve it via {@link useStorefrontApi} (mirrors the
 * portal's PortalErpProvider).
 */
export function StorefrontApiProvider({ children }: { children: ReactNode }) {
  const service = useMemo(() => new StorefrontApiService(getAccessToken), []);
  return (
    <StorefrontApiContext.Provider value={service}>
      {children}
    </StorefrontApiContext.Provider>
  );
}

export function useStorefrontApi(): StorefrontApiService {
  const service = useContext(StorefrontApiContext);
  if (!service) {
    throw new Error(
      'useStorefrontApi must be used within a StorefrontApiProvider'
    );
  }
  return service;
}
